import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import Hammer from "@egjs/hammerjs";
import { DEG_RAD } from "./constants";
import IndiscreteGestureHandler from "./IndiscreteGestureHandler";
var RotationGestureHandler = /*#__PURE__*/ function(IndiscreteGestureHandler) {
    "use strict";
    _inherits(RotationGestureHandler, IndiscreteGestureHandler);
    var _super = _create_super(RotationGestureHandler);
    function RotationGestureHandler() {
        _class_call_check(this, RotationGestureHandler);
        return _super.apply(this, arguments);
    }
    _create_class(RotationGestureHandler, [
        {
            key: "name",
            get: function get() {
                return "rotate";
            }
        },
        {
            key: "NativeGestureClass",
            get: function get() {
                return Hammer.Rotate;
            }
        },
        {
            key: "transformNativeEvent",
            value: function transformNativeEvent(param) {
                var rotation = param.rotation, velocity = param.velocity, center = param.center;
                var _this_initialRotation;
                return {
                    rotation: (rotation - ((_this_initialRotation = this.initialRotation) !== null && _this_initialRotation !== void 0 ? _this_initialRotation : 0)) * DEG_RAD,
                    anchorX: center.x,
                    anchorY: center.y,
                    velocity: velocity
                };
            }
        }
    ]);
    return RotationGestureHandler;
}(IndiscreteGestureHandler);
export default RotationGestureHandler;
